import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { TopBar } from "./TopBar";
import { BottomTabBar } from "./BottomTabBar";
import { InstallBanner } from "./InstallBanner";
import { usePushNotification } from "../../hooks/usePushNotification";

export function AppShell() {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  usePushNotification();

  return (
    <div className="flex h-dvh overflow-hidden bg-[#f8fafc]">
      <Sidebar
        collapsed={collapsed}
        onToggle={() => setCollapsed((v) => !v)}
        mobileOpen={mobileOpen}
        onMobileClose={() => setMobileOpen(false)}
      />
      <div className="flex flex-col flex-1 min-w-0 min-h-0 overflow-hidden">
        <TopBar onMenuToggle={() => setMobileOpen((v) => !v)} />
        <InstallBanner />
        {/* overscroll-y-none prevents pull-to-refresh on Android/Chrome */}
        {/* min-h-0 is required on iOS Safari — without it flex-1 children can't scroll */}
        <main
          className="flex-1 min-h-0 overflow-y-auto overscroll-y-none px-4 pt-4 pb-32 md:px-6 md:pt-6 md:pb-6"
        >
          <Outlet />
        </main>
      </div>
      <BottomTabBar />
    </div>
  );
}
